export default function FilterIcon() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.7914 10.4088H10.3148C10.0049 10.4088 9.73926 10.1431 9.73926 9.83326C9.73926 9.52338 10.0049 9.25775 10.3148 9.25775H24.7914C25.1013 9.25775 25.3669 9.52338 25.3669 9.83326C25.3669 10.1431 25.1013 10.4088 24.7914 10.4088Z"
        fill="#FFFFF2"
      />
      <path
        d="M5.79818 10.4088H3.54035C3.23044 10.4088 2.96484 10.1431 2.96484 9.83326C2.96484 9.52338 3.23047 9.25775 3.54035 9.25775H5.79818C6.10809 9.25775 6.37368 9.52338 6.37368 9.83326C6.37368 10.1431 6.15233 10.4088 5.79818 10.4088Z"
        fill="#FFFFF2"
      />
      <path
        d="M24.7892 18.8541H20.9818C20.6718 18.8541 20.4062 18.5885 20.4062 18.2786C20.4062 17.9688 20.6719 17.7031 20.9818 17.7031H24.7892C25.0991 17.7031 25.3647 17.9688 25.3647 18.2786C25.3647 18.5885 25.0991 18.8541 24.7892 18.8541Z"
        fill="#FFFFF2"
      />
      <path
        d="M16.4674 18.8541H3.54035C3.23044 18.8541 2.96484 18.5885 2.96484 18.2786C2.96484 17.9688 3.23047 17.7031 3.54035 17.7031H16.4674C16.7773 17.7031 17.0429 17.9688 17.0429 18.2786C17.0429 18.5885 16.7773 18.8541 16.4674 18.8541Z"
        fill="#FFFFF2"
      />
      <path
        d="M8.0555 12.6667C6.50601 12.6667 5.22217 11.3828 5.22217 9.83333C5.22217 8.28384 6.50601 7 8.0555 7C9.60499 7 10.8888 8.28384 10.8888 9.83333C10.8888 11.3828 9.64925 12.6667 8.0555 12.6667ZM8.0555 8.1509C7.12583 8.1509 6.37321 8.90349 6.37321 9.83319C6.37321 10.7629 7.1258 11.5155 8.0555 11.5155C8.9852 11.5155 9.73779 10.7629 9.73779 9.83319C9.73779 8.90349 8.9852 8.1509 8.0555 8.1509Z"
        fill="#FFFFF2"
      />
      <path
        d="M18.7279 21.112C17.1784 21.112 15.8945 19.8281 15.8945 18.2786C15.8945 16.7292 17.1784 15.4453 18.7279 15.4453C20.2774 15.4453 21.5612 16.7292 21.5612 18.2786C21.5612 19.8281 20.3216 21.112 18.7279 21.112ZM18.7279 16.5962C17.7982 16.5962 17.0456 17.3488 17.0456 18.2785C17.0456 19.2082 17.7982 19.9608 18.7279 19.9608C19.6576 19.9608 20.4102 19.2082 20.4102 18.2785C20.4102 17.3488 19.6576 16.5962 18.7279 16.5962Z"
        fill="#FFFFF2"
      />
    </svg>
  );
}
